<script setup lang="ts">
import { features } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'
import WlIcon from './WlIcon.vue'

const { registerReveal } = useLandingScroll()
</script>

<template>
  <section class="wl-features-section" id="features">
    <div class="container">
      <div class="section-head reveal" :ref="registerReveal">
        <div class="section-tag">Funcionalidades</div>
        <h2 class="section-title">Todo lo que necesitas<br />para <span class="gradient-text">aprobar</span></h2>
      </div>

      <div class="wl-features-grid">
        <div
          v-for="(feature, index) in features"
          :key="feature.title"
          class="wl-feat-card"
          :class="[
            { 'wl-feat-large': feature.large, 'wl-feat-dark': feature.dark },
            `reveal reveal-d${(index % 4) + 1}`
          ]"
          :ref="registerReveal"
        >
          <div class="wl-feat-icon"><WlIcon :name="feature.icon" /></div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
          <div v-if="feature.stat" class="wl-feat-stat">{{ feature.stat }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
